module.exports = __webpack_public_path__ + "img/firebase.d21a0ff4.svg";